import i18n from "i18next";
import ChainedBackend from "i18next-chained-backend";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { useTranslation, withTranslation } from "react-i18next";
import { URL_PREFIX } from "../config/config";

const getLangFromUrl = () => {
  const url = window.location.pathname.split("/");
  switch (url[1]) {
    case "ru":
      window.current_lang = "ru";
      return "ru";
    case "en":
      window.current_lang = "en";
      return "en";
    default:
      window.current_lang = "ka";
      return "ka";
  }
};

i18n
  .use(ChainedBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    //saveMissing: true,
    whitelist: ["ka", "ru", "en"],
    fallbackLng: ["ka", "ru", "en"],
    debug: false,
    lng: /*localStorage.getItem("i18nextLng")*/ getLangFromUrl() || "ka",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    ns: ["main"],
    defaultNS: "main",
    react: {
      bindI18n: "languageChanged",
      bindI18nStore: "lang",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "!", "'", "."],
      wait: true,
      useSuspense: false,
      /*useSuspense: true,*/
    },
    backend: {
      backends: [HttpBackend],
      backendOptions: [
        {
          loadPath: URL_PREFIX.concat(
            `/locales/{{lng}}.json?${process.env.REACT_APP_VERSION}`
          ),
          //addPath: '/locales/{{lng}}/{{ns}}.missing.json',
        },
      ],
    },
  });
export { i18n, withTranslation, useTranslation };
